import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
    Box,
    Typography,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider,
    Table,
    TableBody,
    Tab,
    Tabs,
    TableRow,
    TableCell,
    colors
} from '@material-ui/core';

import EditShowroom from '../../../EditShowroom/EditShowroom';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    root: {},

    content: {
        padding: 0
    },

    actions: {
        justifyContent: 'flex-end',
        flexDirection: 'row',
        alignItems: 'flex-end',
        '& > * + *': {
            marginLeft: 0
        }
    },

    buttonIcon: {
        marginRight: theme.spacing(1)
    },

    editButton: {
        color: theme.palette.white,
        backgroundColor: colors.blue[600],
        '&:hover': {
            backgroundColor: colors.blue[900]
        }
    },

    createButton: {
        color: theme.palette.white,
        backgroundColor: colors.red[600],
        '&:hover': {
            backgroundColor: colors.red[900]
        }
    }

}));


export default class DetailData extends React.Component {

    constructor(props) {
        super(props);
        console.log('DetailData');
        console.log(props);
        this.state = {
            property: props.property,
            currentTab: 0,
            property_id: props.property_id
        };
    }

    componentWillReceiveProps(props) {
        this.setState({
            property: props.property
        });
    }

    // const {  className, ...rest } = props;
    // const admins = props.admins;
    // const classes = useStyles();

    // const [openEdit, setOpenEdit] = useState(false);

    handleEditOpen() {
        //setOpenEdit(true);
    };

    handleEditClose() {
        //setOpenEdit(false);
    };
    handleChange(event, newValue) {
        this.setState({
            ...this.state,
            currentTab: newValue
        });
    };
    toPage(property_id) {
        window.location.href = '/property/detailproperty/' + property_id;
    };

    render() {
        return (
            <Card
                {...this.props.rest}
                className={clsx(this.props.classes.root, this.props.className)}
            >
                <CardHeader title="Showroom Detail" />
                <Divider />
                <CardContent className={this.props.classes.content}>
                    <Tabs value={this.state.currentTab} onChange={this.handleChange}>
                        <Tab label="Standard"  {...a11yProps(0)}></Tab>
                        <Tab label="Special Days"  {...a11yProps(1)}></Tab>
                    </Tabs>
                    <TabPanel value={this.state.currentTab} index={0}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>
                                        {this.state.property.name}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Description</TableCell>
                                    <TableCell>{this.state.property.email}</TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>Max Appointments Per Slot</TableCell>
                                    <TableCell>{this.state.property.max_appointment}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Max Pax Per Appointment</TableCell>
                                    <TableCell>{this.state.property.max_pax}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Require showroom unit ?</TableCell>
                                    <TableCell>{this.state.property.require_showroom_unit == '1' ? 'Yes' : 'No'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Require guest nationality ?</TableCell>
                                    <TableCell>{this.state.property.require_nationality == '1' ? 'Yes' : 'No'}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TabPanel>

                </CardContent>
                <CardActions className={this.props.classes.actions}>
                    {/* <Button className={this.props.classes.editButton} onClick={this.handleEditOpen}>
                        Edit
                    </Button> */}

                </CardActions>
                {/* <EditShowroom
                    property={this.state.property}
                    onClose={this.handleEditClose}
                    open={this.openEdit}
                /> */}
            </Card>
        );
    }
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
